import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useIdleTimer } from 'react-idle-timer';

//actions
import { showModal } from '@actions/common/actionCreators';

//types
import { commonModalTypes as MODAL_TYPES } from '@constants/common/modals/commonModalTypes';

const useSessionIdle = () => {

    const [ modalData, setmodalData ] = useState({});
    const [ idleTimerConfig, setIdleTimerConfig ] = useState({});

    const idleTimerRef = useRef(null);
    const isIdleRef = useRef(false);
    const dispatch = useDispatch();

    const initSessionIdle = (anonymous, clientInactivityThreshold, popupThresholdValue,logoutUrl) => {

        const onHandleReset = () => {
            isIdleRef.current = false;
            if(idleTimerRef.current) {
                idleTimerRef.current.activate();
            }
        };
      
        setmodalData({
            logoutUrl,
            clientInactivityThreshold,
            popupThresholdValue,
            onHandleReset
        });

        const isDisabled = (anonymous === true || !clientInactivityThreshold);

        setIdleTimerConfig({
            timeout: (clientInactivityThreshold - popupThresholdValue) * 1000,
            events: ['keydown', 'click', 'keyup'], // Events to listen for activity
            onIdle: () => onIdle(isDisabled),
            onActive,
            debounce: 500,
            disabled: isDisabled
        });
    };
    
    const onIdle = (isDisabled) => {
        isIdleRef.current = true;
        if(!isDisabled) {
            return dispatch(showModal({
                modalType: MODAL_TYPES.SESSION_IDLE_WARNING_MODAL,
                modalData: modalData
            }));
        }
    };
       

    const onActive = () => {
        if (isIdleRef.current) {
            isIdleRef.current = false;
        }
    };
    
    const idleTimer = useIdleTimer({ ...idleTimerConfig, ref: idleTimerRef });

    return {
        initSessionIdle,
        idleTimer
    };
};

export default useSessionIdle;